import Exposure from '@/utils/exposure'

const exposure = new Exposure()

export default {
  beforeMount(el) {
    exposure.add(el)
  }
}
